import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-list-layout',
  templateUrl: './page-list-layout.component.html',
  styleUrls: ['./page-list-layout.component.scss']
})
export class PageListLayoutComponent {
  @Input() title: string = '';
  @Input() showHeader: boolean = true;
  @Input() cardDefault: boolean = true;
}
